<template>
    <v-expansion-panel class="">
    <v-expansion-panel-content class="blue textwhite">
      <template v-slot:header>
        <div class="title">{{docTitle}}</div>
      </template>
      <v-layout row>
      <v-flex xs12 sm6>
        <v-list dense> 
            <v-list-tile >
                <v-list-tile-action>
                <v-icon>person</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>{{$store.state.customer.no}}
                -
                {{$store.state.customer.name}}</v-list-tile-title>
                </v-list-tile-content>            
            </v-list-tile>
            <v-divider inset></v-divider>                     
            <v-list-tile >
                <v-list-tile-action>
                <v-icon>email</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>
                    {{$store.state.customer.email}}
                </v-list-tile-title>
                </v-list-tile-content>            
            </v-list-tile>                        
        </v-list>      
      </v-flex>
      <v-flex xs12 sm6>
        <v-list dense>             
            <v-list-tile >
                <v-list-tile-action>
                <v-icon>group</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>
                    {{$store.state.customer.customerPriceGroup}}
                </v-list-tile-title>
                </v-list-tile-content>            
            </v-list-tile>
            <v-divider inset></v-divider>                      
            <v-list-tile >
                <v-list-tile-action>
                <v-icon>payment</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>
                    {{$store.state.customer.Payment}}
                </v-list-tile-title>
                </v-list-tile-content>            
            </v-list-tile>                    
        </v-list>      
      </v-flex>
      </v-layout>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
export default {
    name: 'cabeceraPedido',
    data(){
        return {
            docTitle: ''
        }
    },
    computed:{
        
        
    },
    mounted(){
        this.docTitle = this.getDocTitle();
    }

}
</script>
<style scoped>
.textwhite{
    color: white !important
    }
</style>

